
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ASK_POPUP_TYPE } from "@/constants/popupTypes";
import { SMRoles } from "@/store";

@Component
export default class SLRoleTemplatePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly subtitle!: string;

  askPopupType = ASK_POPUP_TYPE;

  showPopup = false;

  // TODO: Refactor it, after refactoring "Nb-dialog" component;
  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  async createRoleTemplate() {
    this.close();

    await SMRoles.createRoleTemplate();
  }

  async createRoleTemplateFromSL() {
    this.close();

    await SMRoles.createRoleTemplate(true);
  }
}
